import {
    Action
} from 'one-state';

import {
    SET_MATCH_TYPE,
    SET_MATCH_FROM,
    REINIT,
    PatientMatchType,
    PatientMatchFrom
} from './types';

/** 
* Redux action creator to set patient match type
* @param verified object with values 
* @returns action instance 
*/
export const setMatchTypeAction = (matchType: PatientMatchType):
    Action<typeof SET_MATCH_TYPE, PatientMatchType> => ({
        type: SET_MATCH_TYPE,
        payload: matchType
    });

/**
 * where the match is from - global search or identify flow?
 * @param matchFrom 
 * @returns 
 */
export const setMatchFromAction = (matchFrom: PatientMatchFrom):
    Action<typeof SET_MATCH_FROM, PatientMatchFrom> => ({
        type: SET_MATCH_FROM,
        payload: matchFrom
    });
/** 
*Re-initialize the state 
* @returns action instance 
*/
export const reinitAction = ():
    Action<typeof REINIT> => ({
        type: REINIT,
    });
/** 
* List of all valid actions 
*/
export type Actions =
    ReturnType<typeof setMatchTypeAction> |
    ReturnType<typeof setMatchFromAction> |
    ReturnType<typeof reinitAction>